import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { SharePlanUnionType } from '../../types/pool-plans.types';
import { useAppQuery } from '../use-app-query.hook';

export const useSharePlan = ({ companyId, planId }: { companyId: string; planId: string }) => {
  const queryClient = useQueryClient();

  const { data: sharePlan, isLoading } = useAppQuery<SharePlanUnionType>({
    queryKey: [QueryKey.GET_SHARE_PLAN, companyId, planId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'share-plans', planId],
      }),
    enabled: !!companyId && !!planId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SHARE_PLAN] });
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_VESTING_GRAPH] });
  }, [queryClient]);

  return {
    invalidateQuery,
    sharePlan,
    isLoading,
  };
};
